<div class="tracking-container">
  @if (amount() > 0) {
    <div class="summary-card mat-z-elevation-3">
      <div class="summary-header">
        <svg lucideReceipt></svg>
        <h3>Resumen de Mi Consumo</h3>
      </div>
      <div class="summary-body">
        <div class="summary-row">
          <span class="label">Subtotal</span>
          <span class="value">{{ amount() | clpFormat }}</span>
        </div>
        <div class="summary-row">
          <span class="label">Propina sugerida (10%)</span>
          <span class="value">{{ (amount() * 0.1) | clpFormat }}</span>
        </div>
        <div class="summary-row total-row">
          <span class="label">Total Estimado</span>
          <span class="value">{{ (amount() + amount() * 0.1) | clpFormat }}</span>
        </div>
      </div>
    </div>
  }

  @for (item of ownOrders(); track $index) {
    <div [ngClass]="item.statusOrder" class="status-card mat-z-elevation-3">
      <div class="card-header-row">
        <div class="product-main">
          <span class="product-name">{{ item.product }}</span>
          <span class="customer-name">Pedido por: {{ item.customerName }}</span>
        </div>
        @if (item.status === 'created') {
          <button (click)="cancelProduct(item)" class="delete-btn">
            <svg lucideTrash></svg>
          </button>
        }
      </div>
      <div class="card-meta-row">
        <div class="badge quantity-badge">
          <svg lucideHash></svg>
          <span>{{ item.quantity }} unid.</span>
        </div>
        <div class="badge price-badge">
          <svg lucideDollarSign></svg>
          <span>{{ item.price | clpFormat }}</span>
        </div>
      </div>
      <div class="status-timeline">
        <div
          [class.active]="item.status === 'created' || item.status === 'preparing'  || item.status === 'delivered' || item.status ==='print'"
          class="step">
          <div class="icon-circle">
            <svg lucideReceipt></svg>
          </div>
          <span class="label">Recibido</span>
        </div>
        <div [class.completed]="item.status === 'preparing' || item.status === 'delivered' || item.status ==='print'"
             class="connector"></div>
        <div [class.active]="item.status === 'preparing'  || item.status === 'delivered' || item.status ==='print'"
             class="step">
          <div class="icon-circle">
            <svg lucideCookingPot></svg>
          </div>
          <span class="label">Cocina</span>
        </div>
        <div [class.completed]=" item.status === 'delivered'" class="connector"></div>
        <div [class.active]="item.status === 'delivered'" class="step">
          <div class="icon-circle">
            <svg lucideHandPlatter></svg>
          </div>
          <span class="label">Entregado</span>
        </div>
      </div>
      @if (item.notes) {
        <div class="notes-container mat-z-elevation-2">
          <svg lucideFileText></svg>
          <p class="item-notes">"{{ item.notes }}"</p>
        </div>
      }
    </div>
  } @empty {
    <div class="empty-tracking">
      <svg class="empty-state-icon" lucideFrown></svg>
      <p>No hay productos en preparación para tu mesa.</p>
    </div>
  }

  <div class="tracking-bottom-bar glass-effect anim-slide-in-up">
    <div class="actions-wrapper">
      <footer class="view-footer anim-slide-in-up">
        @if (!sessionStore.isOrderLocked()) {
          <button (click)="callWaiter()" class="btn-action primary" mat-flat-button>
            GARZÓN
          </button>
        }
        @if (totalAmount() >= 1) {
          @if (!sessionStore.isOrderLocked()) {
            <button (click)="requestBill()" class="btn-action accent" mat-flat-button>
              CUENTA
            </button>
          } @else {
            <div class="btn-action primary disabled-state">
              <span>Cuenta en camino</span>
            </div>
          }
        }
      </footer>
    </div>
  </div>
</div>
